// extracted by mini-css-extract-plugin
export default {"auditionsSection":"AuditionsSection_auditionsSection__tLo9W","container":"AuditionsSection_container__y-SH2","auditionCardsGrid":"AuditionsSection_auditionCardsGrid__FzujT"};